import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ActivityFeedSection } from '@apps/web/components/settings/activity_feed_section';
import {
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/activity-feed')({
    component: ActivityFeedPage,
});

function ActivityFeedPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }
    return (
        <SettingsPageShell
            title="Activity feed"
            description="Choose what appears in your activity feed."
        >
            <ActivityFeedSection organizationId={organizationId} />
        </SettingsPageShell>
    );
}
